import { PdfProofRender } from '@/components/pdfRender/PdfProofRender'
import { PdfFinalizedRender } from '@/components/pdfRender/PdfFinalizedRender'
import { usePdfRender } from '@/hooks/pdf/usePdfRender'
import type {
  BackgroundTypeKey,
  Content,
  EditorOrderPageDetailsNormalized,
} from '@messenger/types'

export type PdfRenderProps = {
  backgroundType: BackgroundTypeKey
  concatenatedPages: Content['pageProperties']['concatenatedPages']
  data: EditorOrderPageDetailsNormalized
  isPDF: boolean
  pages: (Content | null)[]
  proof: boolean
  contentDimensions: { width: number; height: number }
  scale: number
  nonClippedProducts?: string[]
  contextReady?: boolean
}

export const PdfRender = ({ proof }: { proof: boolean }) => {
  const {
    pages,
    data,
    backgroundType,
    concatenatedPages,
    contentDimensions,
    scale,
    contextReady,
  } = usePdfRender()

  const renderProps = {
    isPDF: true,
    backgroundType,
    data,
    concatenatedPages,
    pages,
    // proof specific props
    proof,
    contentDimensions,
    scale,
    contextReady,
  }

  if (proof) {
    return <PdfProofRender {...renderProps} />
  } else {
    return <PdfFinalizedRender {...renderProps} />
  }
}
